import { Grid, Typography } from "@gupshup-frontend/gupshup-ts-components";

import Image                from "./Image";
import styles               from "./style.module.css";
import { TEMPLATE_ICONS }   from "./constant";

function PayNowPanel() {
  return (
    <Grid sx = {{mb : 1}}>
      <Grid className = {styles.payNowPanelAmount}>
        <Typography variant = 'body2' fontWeight = {500}>[Payment Amount]</Typography>
      </Grid>
      <Grid className = {styles.payNowPanelPayWith}>
        <Typography variant = "body2" fontSize = {12} fontWeight = {500} flex = 'none'>Pay with</Typography>
        <Grid container gap = {1} justifyContent = "flex-end" flexWrap = 'nowrap'>
          <Image src = {TEMPLATE_ICONS.UPI} alt = "UPI" width = 'auto' height = {32} className = {styles.payNowPanelPayWithIcon} />
          <Image src = {TEMPLATE_ICONS.VISA} alt = "VISA" width = 'auto' height = {32} className = {styles.payNowPanelPayWithIcon} />
          <Image src = {TEMPLATE_ICONS.MASTERCARD} alt = "MASTERCARD" width = 'auto' height = {32} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PayNowPanel;
